module.exports = __webpack_public_path__ + "assets/yu.187bda8a.svg";